module.exports = {
  TMDBapiKey: process.env.REACT_APP_TMDB_API_KEY
}